/* Theme-owned behavior for the two explicitly audited support pages.
 * Form and app submission are left to their existing Shopify/Hulk owners.
 */
(() => {
  'use strict';
  const roots = '[data-native-support-page]';
  const wrapperClass = 'nsp-2753c20e944f';
  const showClass = 'nsp-2ec967685c24';
  const hideClass = 'nsp-7736dfa84d89';
  const showingClass = 'nsp-e7b525cea995';
  const hidingClass = 'nsp-aa7c20ef824e';
  const animatedClass = 'nsp-ef245220474b';
  const device = () => innerWidth <= 767 ? 'mobile' : innerWidth <= 1024 ? 'tablet' : innerWidth <= 1200 ? 'laptop' : 'all';
  const imagesReady = panel => Promise.all([...panel.querySelectorAll('img')].map(image => image.complete ? Promise.resolve() : new Promise(resolve => {
    image.addEventListener('load', resolve, {once: true});
    image.addEventListener('error', resolve, {once: true});
  })));

  // Source waits for layout visibility before measuring the accordion answer.
  function whenVisible(panel, callback) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          callback();
          observer.disconnect();
        }
      });
    });
    observer.observe(panel);
  }

  function initialize(root) {
    if (root.dataset.nativeSupportReady) return;
    root.dataset.nativeSupportReady = 'true';
    root.querySelectorAll('[data-native-kind="Accordion"]').forEach(group => {
      const entries = [...group.querySelectorAll('[data-native-kind="Accordion.Header"]')].map(header => {
        const panel = [...group.querySelectorAll('[data-native-kind="Accordion.Content"]')].find(node => node.dataset.id === header.dataset.headerId);
        const wrapper = document.createElement('div');
        wrapper.className = wrapperClass;
        const resize = () => { wrapper.style.height = header.dataset.active === 'true' ? `${panel.clientHeight}px` : '0px'; };
        resize();
        panel.style.display = '';
        wrapper.classList.add(header.dataset.active === 'true' ? showClass : hideClass);
        panel.parentElement.append(wrapper); wrapper.append(panel);
        new MutationObserver(resize).observe(panel, {subtree: true, attributes: true});
        whenVisible(panel, () => { resize(); imagesReady(panel).then(resize); });
        window.addEventListener('resize', resize);
        function set(open, animationHost = wrapper) {
          header.dataset.active = String(open); header.setAttribute('aria-expanded', String(open));
          wrapper.classList.remove(open ? hidingClass : showClass, open ? hideClass : showingClass);
          wrapper.classList.add(open ? showingClass : hidingClass);
          if (open) whenVisible(panel, () => imagesReady(panel).then(resize));
          animationHost.addEventListener('animationend', () => {
            wrapper.classList.add(open ? showClass : hideClass);
            wrapper.classList.remove(open ? showingClass : hidingClass);
          }, {once: true});
        }
        return {header, panel, wrapper, set};
      });
      entries.forEach(entry => entry.header.addEventListener('click', event => {
        event.stopPropagation();
        const open = entry.header.dataset.active !== 'true';
        entry.set(open);
        if (group.dataset.multiple === 'false') entries.filter(other => other !== entry).forEach(other => other.set(false, entry.wrapper));
      }));
    });

    root.querySelectorAll('[data-native-href]').forEach(element => {
      element.addEventListener('click', event => {
        event.stopPropagation();
        window.open(element.getAttribute('data-native-href'), event.ctrlKey || event.metaKey ? '_blank' : element.getAttribute('data-target') || '_self');
      });
    });
    const breakpoint = device();
    root.querySelectorAll('[data-native-scroll-target]').forEach(button => {
      const offset = JSON.parse(button.getAttribute('data-offset'));
      const target = root.querySelector(`[data-native-group="${button.getAttribute('data-native-scroll-target')}"]`);
      if (!target) throw new Error('Missing support anchor target');
      button.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        const initial = scrollY;
        const distance = target.getBoundingClientRect().top - (Number(offset[breakpoint]) || 0);
        const started = Date.now();
        const scroll = () => {
          const progress = Math.min(1, (Date.now() - started) / 1000);
          window.scrollTo({top: initial + (1 - Math.pow(1 - progress, 3)) * distance});
          if (progress < 1) requestAnimationFrame(scroll);
        };
        scroll();
      });
    });
    root.querySelectorAll('[data-native-support-animation]').forEach(element => {
      const animation = element.getAttribute('data-native-support-animation');
      const play = () => {
        element.style.visibility = 'visible'; element.classList.add(animatedClass, animation);
        element.onanimationend = () => setTimeout(() => element.classList.remove(animatedClass), 2000);
      };
      if (!window.IntersectionObserver) { play(); return; }
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting && (entry.intersectionRatio >= .25 || entry.boundingClientRect.height * .25 > (entry.rootBounds?.height || innerHeight))) {
          play(); observer.unobserve(element);
        }
      }), {threshold: [0, .25], rootMargin: '0px'});
      observer.observe(element);
    });
  }
  function init(scope) {
    const targets = [...scope.querySelectorAll(roots)];
    if (scope.matches?.(roots)) targets.unshift(scope);
    targets.forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once: true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
